import St from '../../screens/LoginScreen/LoginScreen.module.css';

const InputBox = ({
  label,
  subLabel,
  id,
  type,
  autoFocus,
  placeholder,
  autoComplete,
  maxLength,
  disabled,
  icon,
  iconStyle,
  overrideIcon,
  value,
  onChange,
  errorMessage,
  loadingText,
  image,
  imageAlt,
  imageKey,
  additionalClass,
  onPasswordToggle,
  ariaLabelToggle,
  toggleIcon,
  customToggleIcon,
}) => {
  return (
    <div className={St.field}>
      <label className={`${St.fieldLabel} ${additionalClass || ''}`} htmlFor={id}>
        {label}
      </label>
      {subLabel ? <p style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>{subLabel}</p> : null}

      {loadingText ? <p style={{ fontSize: 13, color: '#64748b' }}>{loadingText}</p> : null}
      {image && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 16 }}>
          <img src={image} alt={imageAlt} style={{ width: 160, height: 160, border: '1px solid #e2e8f0', borderRadius: 8, marginBottom: 8 }} />
          {imageKey && <p style={{ fontSize: 11, color: '#94a3b8', wordBreak: 'break-all', textAlign: 'center' }}>Manual key: {imageKey}</p>}
        </div>
      )}
      <div className={St.fieldBox}>
        <input
          id={id}
          type={type || 'text'}
          className={`${St.fieldInput} ${errorMessage ? St.fieldInputError : ''}`}
          maxLength={maxLength}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
        />
        {overrideIcon ? (
          overrideIcon
        ) : (
          <svg className={St.fieldIcon} style={iconStyle}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
          </svg>
        )}
        <button type='button' className={St.eyeToggle} onClick={onPasswordToggle} aria-label={ariaLabelToggle}>
          {customToggleIcon ? customToggleIcon : <svg>
            <use xlinkHref={`/assets/sprite.svg#icon-${toggleIcon}`} />
          </svg>}
        </button>
      </div>
      {errorMessage ? <div className={St.fieldError}>{errorMessage}</div> : null}
    </div>
  );
};

export default InputBox;
